import * as React from 'react';
import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
  <path d="M4.99718 0C4.8993 0 4.80896 0.0169396 4.72614 0.0508187C4.64333 0.0884623 4.56428 0.144928 4.48899 0.220215L0.186335 4.61886C0.0621118 4.74685 0 4.90119 0 5.08187C0 5.2061 0.0301148 5.31715 0.0903444 5.41502C0.14681 5.51666 0.223979 5.59759 0.321852 5.65782C0.419725 5.71805 0.530774 5.74816 0.654997 5.74816C0.831922 5.74816 0.990024 5.67852 1.12931 5.53924L4.99718 1.57538L8.86505 5.53924C9.00433 5.67852 9.16431 5.74816 9.345 5.74816C9.46546 5.74816 9.57463 5.71805 9.6725 5.65782C9.77414 5.59759 9.85319 5.51666 9.90966 5.41502C9.96988 5.31715 10 5.2061 10 5.08187C10 4.90119 9.93601 4.74685 9.80802 4.61886L5.50536 0.220215C5.43008 0.144928 5.35103 0.0884623 5.26821 0.0508187C5.18539 0.0169396 5.09505 0 4.99718 0Z"/>
</svg>
`;

export const ChevronUp = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
